<template>
  <div class="shared-ending-fields">
    <section class="report-section">
      <h3>{{ $t('other-finding-section') }}</h3>
      <div class="field">
        <label class="label">{{ $t('other-finding') }}</label>
        <div class="checkbox-grid">
          <label v-for="option in otherFindingOptions" :key="option.value" class="checkbox report-checkbox">
            <input
              type="checkbox"
              :value="option.value"
              :checked="report.otherFindings.selected.includes(option.value)"
              @change="toggleCheckbox(report.otherFindings.selected, option.value, $event.target.checked)"
            >
            <span>{{ option.label }}</span>
          </label>
        </div>
      </div>
      <div v-if="report.otherFindings.selected.includes('other')" class="field">
        <label class="label">{{ $t('other-specify') }}</label>
        <textarea class="textarea" rows="2" v-model="report.otherFindings.other" :maxlength="5000"></textarea>
      </div>
    </section>

    <section class="report-section">
      <div class="field-heading">
        <h3>{{ $t('final-interpretation-section') }}</h3>
        <button
          v-if="showSuggestionButton"
          class="button is-small"
          type="button"
          :disabled="!suggestedFinalInterpretation"
          data-testid="generate-final-interpretation-button"
          @click="applySuggestedFinalInterpretation"
        >
          {{ $t('button-generate-final-interpretation') }}
        </button>
      </div>
      <div class="field">
        <label class="label">{{ $t('final-interpretation') }}</label>
        <textarea
          class="textarea"
          rows="5"
          v-model="report.finalInterpretation"
          :maxlength="15000"
          :placeholder="placeholder"
          data-testid="final-interpretation"
        ></textarea>
        <p class="help has-text-right">{{ report.finalInterpretation.length }} / 15000</p>
      </div>
    </section>
  </div>
</template>

<script>
import { optionPairs, translateOptions } from './reportTemplateOptions';

export default {
  name: 'SharedEndingFields',
  props: {
    report: {
      type: Object,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    suggestedFinalInterpretation: {
      type: String,
      default: ''
    },
    showSuggestionButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    otherFindingOptions() {
      return translateOptions(this.$t.bind(this), optionPairs.otherFinding);
    }
  },
  methods: {
    applySuggestedFinalInterpretation() {
      if (this.suggestedFinalInterpretation) {
        this.report.finalInterpretation = this.suggestedFinalInterpretation;
      }
    },
    toggleCheckbox(target, value, checked) {
      const index = target.indexOf(value);
      if (checked && index === -1) {
        target.push(value);
      } else if (!checked && index !== -1) {
        target.splice(index, 1);
      }
    }
  }
};
</script>
